import {
  FaTruck,
  FaUndoAlt,
  FaShieldAlt,
  FaLock,
} from "react-icons/fa";

const features = [
  {
    icon: <FaTruck />,
    title: "Easy Delivery",
    description: "Get your order at your doorstep",
  },
  {
    icon: <FaUndoAlt />,
    title: "7 Days Return",
    description: "Hassle free return policy",
  },
  {
    icon: <FaShieldAlt />,
    title: "100% Original",
    description: "Original products guaranteed",
  },
  {
    icon: <FaLock />,
    title: "Secure Payment",
    description: "Multiple secure payment options",
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-white border border-gray-200 rounded-2xl">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
        {features.map((item, index) => (
          <div
            key={item.title}
            className={`
              flex items-center gap-4 px-8 py-6
              ${
                index !== features.length - 1
                  ? "lg:border-r border-gray-200"
                  : ""
              }
            `}
          >
            <div className="text-blue-600 text-3xl flex-shrink-0">
              {item.icon}
            </div>

            <div>
              <h4 className="font-semibold text-gray-900 text-base">
                {item.title}
              </h4>

              <p className="text-sm text-gray-500 mt-1">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </footer>
  );
}